import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { ILAddClientsView } from '../components/views/ILAddClientsView'

function ILAddClients() {
    return (
        <div className="ilAddClients">
            <Sidebar />
            <MainView>
                <ViewTitle text={'Irresponsible Lending New Clients'} />
                <ILAddClientsView />
            </MainView>
        </div>
    )
}

export default ILAddClients
